import type { ComponentProps } from 'react';
import { Col, InfinityLoading, Row } from 'ui';
import type { NodeTodo, Todo } from '../../../types';
import { TodosWidgetItem, type TodosWidgetItemType } from '../todos-widget-item';

type P = {
  fetchNextPage: () => unknown;
  hasMoreData?: boolean;
  isFetching: boolean;
  items: NodeTodo[] | Todo[];
  loadingColProps?: ComponentProps<typeof Col>;
  rowProps?: ComponentProps<typeof Row>;
  todoColProps?: ComponentProps<typeof Col>;
  todoProps?: Omit<ComponentProps<typeof TodosWidgetItem>, 'todo'>;
  type?: TodosWidgetItemType;
};

const TodosWidgetList = ({
  fetchNextPage,
  hasMoreData,
  isFetching,
  items,
  loadingColProps,
  rowProps,
  todoColProps,
  todoProps,
  type,
}: P) => (
  <Row {...rowProps} gutter={['ms', 0]}>
    {items.map((todo) => (
      <Col key={todo.id} span={24} {...todoColProps}>
        <TodosWidgetItem todo={todo} type={type} {...todoProps} />
      </Col>
    ))}
    {isFetching || hasMoreData ? (
      <Col span={24} {...loadingColProps}>
        <InfinityLoading hasMoreData={hasMoreData} isLoading={isFetching} onEnter={fetchNextPage} />
      </Col>
    ) : null}
  </Row>
);

export default TodosWidgetList;
